import Immutable from 'immutable';

import {
  QUESTIONS_LOADING_START,
  QUESTIONS_LOADING_SUCCESS,
  EVALUATION_LOADING_START,
  EVALUATION_LOADING_SUCCESS,
  STORE_LOADING_SUCCESS,
  STORE_LOADING_START,
  RESET_EVALUATION,
  EVALUATION_SAVING_START,
  EVALUATION_SAVING_SUCCESS,
  EVALUATION_SAVING_ERROR,
  UPDATE_OPEN_QUESTION_TEXT,
} from '../actions/evaluationQuestions';

const initialState = Immutable.fromJS({
  questions: [],
  questionLoadingState: 'IDLE',
  evaluation: [],
  evaluationLoadingState: 'IDLE',
  evaluationSavingState: 'IDLE',
  store: null,
  storeLoadingState: 'IDLE',
  openQuestionsText: {}, // { questionId: textValue }
});

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_EVALUATION: {
      return state
        .set('questionLoadingState', 'IDLE')
        .set('evaluationLoadingState', 'IDLE')
        .set('storeLoadingState', 'IDLE')
        .set('store', null)
        .set('questions', [])
        .set('evaluation', [])
        .set('openQuestionsText', {});
    }
    case QUESTIONS_LOADING_START:
      return state.set('questionLoadingState', 'PENDING');
    case QUESTIONS_LOADING_SUCCESS:
      return state
        .set('questions', Immutable.fromJS(action.data))
        .set('questionLoadingState', 'SUCCESS');

    case EVALUATION_LOADING_START:
      return state.set('evaluationLoadingState', 'PENDING');
    case EVALUATION_LOADING_SUCCESS: {
      const evaluationData = Immutable.fromJS(action.data);
      
      // Estrai i textValue dalle domande aperte e popula openQuestionsText
      let openQuestionsTextMap = {};
      if (evaluationData && evaluationData.size) {
        evaluationData.forEach(item => {
          if (item.get('textValue')) {
            openQuestionsTextMap[item.get('questionId')] = item.get('textValue');
          }
        });
      }

      return state
        .set('evaluation', evaluationData)
        .set('evaluationLoadingState', 'SUCCESS')
        .set('openQuestionsText', openQuestionsTextMap);
    }

    case EVALUATION_SAVING_START:
      return state.set('evaluationSavingState', 'PENDING');
    case EVALUATION_SAVING_ERROR:
      return state.set('evaluationSavingState', 'IDLE');
    case EVALUATION_SAVING_SUCCESS:
      return state
        .set('evaluation', Immutable.fromJS(action.data))
        .set('evaluationSavingState', 'SUCCESS');

    case STORE_LOADING_START:
      return state.set('storeLoadingState', 'PENDING');
    case STORE_LOADING_SUCCESS:
      return state
        .set('store', action.data)
        .set('storeLoadingState', 'SUCCESS')
        .set('evaluationSavingState', 'SUCCESS');

    case UPDATE_OPEN_QUESTION_TEXT: {
      // Salva il testo in una struttura separata key-value (oggetto JavaScript semplice)
      const currentOpenQuestionsText = state.get('openQuestionsText') || {};
      const updatedOpenQuestionsText = {
        ...currentOpenQuestionsText,
        [action.questionId]: action.text,
      };
      return state.set('openQuestionsText', updatedOpenQuestionsText);
    }

    default:
      return state;
  }
}
